import PropTypes from 'prop-types';

export default function OutlineAutomation(props) {
    const { color = 'currentColor', size = 20, strokeWidth = 1.5, ...rest } = props;

    return (
        <svg viewBox="0 0 20 20" fill="none" width={size} height={size} {...rest}>
            <path
                d="m8.413 13.558-.69 2.41-.689-2.41a3.813 3.813 0 0 0-2.62-2.616L2 10.253l2.413-.688a3.813 3.813 0 0 0 2.62-2.616l.69-2.41.69 2.41a3.813 3.813 0 0 0 2.62 2.615l2.414.69-2.413.688a3.812 3.812 0 0 0-2.62 2.615v.001Zm7.162-6.085-.22.876-.22-.876a2.86 2.86 0 0 0-2.081-2.08l-.879-.219.879-.219a2.86 2.86 0 0 0 2.082-2.079l.22-.876.219.876a2.86 2.86 0 0 0 2.082 2.08l.878.218-.878.22a2.86 2.86 0 0 0-2.082 2.079Zm-1.157 10.032-.335 1.002-.334-1.002a1.906 1.906 0 0 0-1.206-1.204l-1.003-.334 1.003-.333a1.906 1.906 0 0 0 1.206-1.205l.334-1.001.335 1.001c.19.569.636 1.015 1.206 1.205l1.003.333-1.003.334c-.57.19-1.017.636-1.207 1.204Z"
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={strokeWidth}
            />
        </svg>
    );
}

OutlineAutomation.propTypes = {
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
    strokeWidth: PropTypes.number,
};
